import angular from 'angular'
import routers from './routers.js'
import searchDeclarationCtrl from './searchDeclarationCtrl.js'
import searchDeclarationDetailCtrl from './searchDeclarationDetailCtrl.js'

export default angular
    .module('declaration.addValTaxDeclaration.searchDeclaration', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('searchDeclarationCtrl', searchDeclarationCtrl)
    .controller('searchDeclarationDetailCtrl', searchDeclarationDetailCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/searchDeclaration/index.js